import React, { useMemo, useState } from "react";

import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";

import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import useWindowSize from "shared/utils/hooks/useWindowSize";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { SingleAuthorContainer } from "./styles";

const SingleAuthor = ({ author }) => {
  const { width } = useWindowSize();
  const isMobile = width <= 450;

  const { setSelectedAuthors, selectedAuthors } = useNewGlobalSearch();
  const [failedToLoadImage, setFailedToLoadImage] = useState(false);

  const userIsAuthor = useMemo(
    () => !!selectedAuthors?.find((index) => index?.id === author?.id),
    [selectedAuthors],
  );

  const handleSelectAuthor = () => {
    if (userIsAuthor)
      setSelectedAuthors((prev) =>
        prev?.filter((item) => item?.id !== author?.id),
      );
    else setSelectedAuthors((prev) => [...prev, author]);
  };

  return (
    <SingleAuthorContainer onClick={() => handleSelectAuthor()}>
      <ConsolePageForm.Checkbox
        checked={userIsAuthor}
        handleChange={() => null}
      />
      <div className="user-infos">
        {author?.avatar || failedToLoadImage ? (
          <img
            className="userPhoto"
            src={author?.avatar}
            alt="Foto do usuário"
            onError={() => setFailedToLoadImage(true)}
          />
        ) : (
          <div className="user-initial">
            <SimpleUserInitialsName fullName={author?.name} smallFormat />
          </div>
        )}
        <div className="user-text-infos">
          <div className="userName">{author?.name}</div>
          {!isMobile && <div className="userEmail">({author?.email})</div>}
        </div>
      </div>
    </SingleAuthorContainer>
  );
};

export default SingleAuthor;
